import { Vue, Component, Prop } from 'vue-property-decorator';

const logoEn = require('../../../assets/logos/corekees-en.svg');
const logoNl = require('../../../assets/logos/corekees-nl.svg');

@Component

export default class Logo extends Vue {
  classes: string[] = ['logo'];

  @Prop({ default: 'medium' })
  size!: string;

  /**
   * Computed property to get
   * the classes of the logo.
   *
   * @return string
   */
  get logoClasses(): string {
    this.classes.push(`logo--${this.size}`);

    return this.classes.join(' ');
  }

  /**
   * Computed property to get the logo src
   * based on the current language.
   *
   * @return string
   */
  get logoSrc(): string {
    const locale = this.$i18n.locale;

    if (locale === 'en') {
      return logoEn;
    }

    return logoNl;
  }
}
